import React, { Component } from "react";
import { AUTH_TOKEN } from '../../constants'
import { AES, mode, pad, enc} from 'crypto-js'; 
import axios from 'axios';
import { useLocation } from "react-router-dom/dist";

const ChangePassword = () => {
    const location = useLocation();
    
    return <ChangePasswordChild location={location} />;
    };

class ChangePasswordChild extends Component {
    
    state = {
        token: "",
        fields: { },
        errors: { },
        isPasswordReset: false
    }

    constructor(props) {
        super(props);
        localStorage.removeItem(AUTH_TOKEN)
        
        const urlParams = new URLSearchParams(this.props.location.search);
        const token = urlParams.get('token')
        
        this.state = {
            token: token,
            fields: {},
            errors: {}
        }
    }

    handleValidation() {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;

        if(!fields["password"]){
            formIsValid = false;
            errors["password"] = "Cannot be empty"
        }

        if(!fields["passwordConfirmation"]){
            formIsValid = false;
            errors["passwordConfirmation"] = "Cannot be empty"
        }

        if(fields["password"].trim() !== fields["passwordConfirmation"].trim()) {
            formIsValid = false;
            errors["submit"] = "Passwords do not match"
        }

        this.setState({errors: errors})
        return formIsValid;
    }

    handleChange(field, e) {
        let fields = this.state.fields;
        fields[field] = e.target.value;
        this.setState({fields});
    }

    render() {
        const clientUrl = process.env.REACT_APP_CLIENT_URL
        return (
            <div>
                {this.state.isPasswordReset ? 
                <div>
                    <h4>Password reset sucessfully</h4>
                    <a class="button" href={clientUrl}>Sign in</a>
                </div> :
                <div>
                    <h4>Choose a New Password</h4>
                    <p>Create a new password . A strong password is combination of letters, numbers and punctuation marks.</p>
                    
                    <form>
                        <input type="text" autoComplete="username" hidden={true} />
                        <input
                            onChange={this.handleChange.bind(this, "password")}
                            type="password"
                            placeholder="Password"
                            autoComplete="password"
                        />
                        <br/>
                        <span className="error">{this.state.errors["password"]}</span>
                        <br/>
                        <input
                            onChange={this.handleChange.bind(this, "passwordConfirmation")}
                            type="password"
                            placeholder="Password Confirmation"
                            autoComplete="new-password"
                        />
                        <br/>
                        <span className="error">{this.state.errors["passwordConfirmation"]}</span>
                        <br/>
                        {/* <Mutation mutation={CHANGE_PASSWORD_MUTATION}>
                            {(changePassword, {data, _, error }) => {
                                return ( */}
                                    <div>
                                        <div className="pointer mr2 button" onClick={async () => {
                                            if(this.handleValidation()) {
                                                try {
                                                    let password = this.state.fields["password"]
                                                    let passwordConfirmation = this.state.fields["passwordConfirmation"]

                                                    // const response = await generateNounce({ variables: {reason: this.state.reason}})
                                                    let reason = `passreset.${this.state.token}`
                                                    const response = await axios.post(process.env.REACT_APP_BACKEND_URL+"/api/nounce/generate_nounce", { reason });
                                                    
                                                    const nounce = response.data.nounce || "+LctPbVmVnEt8F2Tv0Cfog==";
                                                
                                                    const eky = process.env.CRYPTOK || "UwXPEH9gc54XkXKtr8J7nukInrHBrjz3P1Ty+Bv6QeA=";

                                                    const key = enc.Base64.parse(eky);
                                                    console.log("nounce: " + nounce)
                                                    const iv = enc.Base64.parse(nounce || "");
                                                    password = passwordConfirmation = AES.encrypt(password, key, {
                                                        iv,
                                                        mode: mode.CBC,
                                                        padding: pad.Pkcs7
                                                    }).toString();
                                                    console.log("Token: "+this.state.token)
                                                    const responsePasswordChange = await axios.post(process.env.REACT_APP_BACKEND_URL+"/api/auth/reset-password", { 
                                                        password: password, 
                                                        passwordConfirmation: passwordConfirmation, 
                                                        code: this.state.token
                                                    });

                                                    //TODO: handle correct reset
                                                    this.setState({isPasswordReset: true})
                                                    console.log(responsePasswordChange)
                                                    console.log(responsePasswordChange.code)
                                                } catch(e) {
                                                    let error = ""
                                                    // console.log(e.response.data.message)
                                                    for(let i in e.response.data.message) {
                                                        for(let j in e.response.data.message[i].messages) {
                                                            console.log(e.response.data.message[i].messages[j])
                                                            error += "\n" + e.response.data.message[i].messages[j].message
                                                        }
                                                    }
                                                    alert("Something went wrong while reseting password: "+ error)
                                                }
                                            }
                                        } }>
                                            {'Change password'}
                                        </div>
                                        <span className="error">{this.state.errors["submit"]}</span>
                                    </div>
                        {/*       )
                            }
                            }
                        </Mutation> */}
                    </form>
                </div>
                }
            </div>
        )
    }
}

export default ChangePassword;